'use strict';

angular.module('atex.dam').controller('DamIconCodingController', [ '$scope', '$http', 'DamMarkAsService', 'DamActivityService','DamNotificationService','$translate',
function($scope, $http, DamMarkAsService, DamActivityService,DamNotificationService, $translate) {
  $scope.getActualIconCoding = function (entry) {
    var metadataAspect = entry._data ? entry._data.aspects["atex.Metadata"] : entry.data.aspects["atex.Metadata"];
    if (metadataAspect !== undefined) {
      var dimension = _.find(metadataAspect.data.metadata.dimensions, function (dim) {
        return dim.id === 'dimension.markas-iconcoding';
      });
      if (dimension) {
        return dimension.entities[0].id;
      }
    }
    return '0';
  };

  $scope.icons = DamMarkAsService.getIcons();
  $scope.ratingRange = $scope.icons.range;
  $scope.ratingIcons = [$scope.icons.icon, $scope.icons.selected];
  var actual = $scope.getActualIconCoding($scope.entry);
  $scope.currentData = {
    currentIconCoding: actual
  };

  $scope.$on("dam:iconCodingUpdate", function (event, update) {
    if ($scope.entry.id === update.id) {
      $scope.currentData.currentIconCoding = update.rating.toString();
      $scope.$root.$broadcast('dam:updatedItem', $scope.entry);
    }
  });

  $scope.rate = function (rating) {
    var oldRating = $scope.currentData.currentIconCoding;
    var locked = false;
    DamActivityService.lock([$scope.entry.id]).then(function (responses) {
      locked = true;
      var idlist = [];
      idlist.push($scope.entry.id);
      var data = {
        'aspects': {
          'contentData': {
            'data': {
              '_type': 'com.atex.onecms.app.dam.markas.DamMarkAsBean',
              'id': JSON.parse(JSON.stringify(idlist)),
              'field': 'iconcoding',
              'value': rating
            }
          }
        }
      };
      var url = "/onecms/dam/content/metadata/markas";
      return $http.put(url, data);
    }).then(function (response) {
      DamActivityService.unlock([$scope.entry.id]);
      $scope.$root.$broadcast('dam:updatedItem', $scope.entry);
    }).then(null, function () {
      if (locked) {
        DamActivityService.unlock([$scope.entry.id]);
      }
      $scope.currentData.currentIconCoding = oldRating;
      DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: $translate.getTranslationTable()._NO_EDIT_PERMISSION_LABEL_}), true);
    });
  };
}]);

angular.module('atex.dam').directive('damIconCoding', function() {

  return {
    restrict: 'EA',

    templateUrl: 'views/dam-icon-coding.html',

    replace: false,

    scope: {
      entry: "="
    },

    controller: 'DamIconCodingController',

    link: function (scope, element, attrs) {
      scope.$watch(function () {
        return scope.entry;
      }, function (newValue, oldValue) {
        var actual = scope.getActualIconCoding(scope.entry);
        scope.currentData = {
          currentIconCoding: actual
        };
      }, true);
    }
  };
});
